import { UpgradeIds } from '../enums'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives = [
	{
		name: 'Copy-Paste Analytics',
		description:
			'Revolutionize data analysis by copying and pasting random numbers repeatedly.'
	},
	{
		name: 'Infinite Loop Processing',
		description:
			'Process the same data forever. The results keep changing somehow.'
	},
	{
		name: 'Random Number Generator',
		description:
			'Replace all actual data with randomly generated numbers. Much faster!'
	},
	{
		name: 'Quantum Data Analysis',
		description:
			'All data points exist in multiple states until observed by management.'
	},
	{
		name: 'Time-Traveling Statistics',
		description:
			'Analyze future data from parallel timelines where statistics make sense.'
	},
	{
		name: 'Multiverse Metrics',
		description:
			'Combine data from infinite parallel universes. The spreadsheets are infinite!'
	},
	{
		name: 'Void Analytics',
		description:
			'Extract data directly from the void. The numbers mean nothing and everything.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Data Mining Firm'],
	departments[DepartmentIds['Data Mining Firm']].basePrice * 3,
	UpgradeIds.DmfExponent1
)

export default array
